module.exports = __webpack_public_path__ + "static/media/solution19.18712f22.png";